import { Link } from "react-router-dom"

export function NotFound() {
  return (
    <div
      className="min-h-[80vh] flex flex-col items-center justify-center px-6 text-center"
      style={{ fontFamily: "'Barlow', sans-serif" }}
    >
      <div
        className="text-8xl font-black text-[#1B5E35] mb-4"
        style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
      >
        404
      </div>
      <h1
        className="text-4xl font-black text-[#F4F6F0] mb-4"
        style={{ fontFamily: "'Barlow Condensed', sans-serif" }}
      >
        PAGE NOT FOUND
      </h1>
      <p className="text-[#6B7C6E] mb-8 max-w-sm">
        The page you're looking for doesn't exist or has been moved.
      </p>
      <Link
        to="/"
        className="bg-[#1B5E35] hover:bg-[#2A7D4A] text-[#F4F6F0] font-bold px-8 py-3 rounded-lg transition-colors text-sm"
      >
        Back to Home
      </Link>
    </div>
  )
}
